import React from "react";
import VenuesTable from "../../components/VenuesTable";
import Page from "../../components/Page";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";

export default () => {
  return (
    <Page title={"Venues"}>
      <VenuesTable />
    </Page>
  );
};
